import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children }) {
    const { user } = useAuth();
    const loc = useLocation();

    if (user === null) {
        // Still checking
        return (
            <div className="min-h-[40vh] flex items-center justify-center">
                <div className="text-mute text-xs tracking-widest">CARICAMENTO…</div>
            </div>
        );
    }
    if (user === false) {
        return <Navigate to="/login" replace state={{ from: loc.pathname + loc.search }} />;
    }
    return children;
}
